import i18n from '@/lib/i18n/i18n';

const SUPPORTED_LOCALES = ['ar', 'en'] as const;

export type AppLocale = (typeof SUPPORTED_LOCALES)[number];

export function isAppLocale(value: string | undefined | null): value is AppLocale {
    return value === 'ar' || value === 'en';
}

/** Sync html lang/dir immediately for the given locale (works even before changeLanguage resolves). */
export function applyDocumentLocale(locale: string) {
    const lng = isAppLocale(locale) ? locale : 'ar';
    const dir = i18n.dir(lng);
    document.documentElement.lang = lng;
    document.documentElement.dir = dir;
    document.dir = dir;
}

export async function changeAppLanguage(locale: string) {
    const lng = isAppLocale(locale) ? locale : 'ar';
    applyDocumentLocale(lng);
    await i18n.changeLanguage(lng);
}
